<template>
  <div class="container">
    <el-card style="margin: 10px">
      <el-row style="height:40px">
        <el-col :span="24">
          <el-form :inline="true" :model="searchParams">
            <el-form-item>
              <el-select v-model="searchParams.production" size="small" placeholder="请选择环境" style="max-width: 120px">
                <el-option key="true" label="线上环境" :value="true"></el-option>
                <el-option key="false" label="测试环境" :value="false">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.method" size="small" placeholder="请选择上报来源" clearable style="max-width: 150px">
                <el-option key="1" label="客户端埋点" :value="1"></el-option>
                <el-option key="3" label="服务端埋点" :value="3">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="searchParams.event" size="small" filterable clearable allow-create
                placeholder="请选择event" style="max-width: 200px">
                <el-option v-for="evt of events" :key="evt.event" :label="evt.event" :value="evt.event">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="device_id" type="text" size="small" v-model="searchParams.device_id"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="IDFV/AndroidId" type="text" size="small" v-model="searchParams.device_id2"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="user_id" type="text" size="small" v-model="searchParams.user_id"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="properties参数:" v-if="searchParams.properties.length > 0">
							<el-tag
								:key="d.key"
								v-for="(d, idx) in searchParams.properties"
								closable
								:disable-transitions="false"
                @click="handleEditTag(idx)"
								@close="handleCloseTag(idx)" style="margin-left: 5px;cursor: pointer">
								<span v-if="d.value">{{d.key}} = {{d.value}}</span>
								<span v-if="!d.value">包含{{d.key}}</span>
							</el-tag>
            </el-form-item>
            <el-form-item>
              <el-button
                type="text"
                size="small"
                icon="el-icon-plus"
                @click="addPropertyParams">添加properties参数</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                icon="el-icon-search"
                @click="queryEvents">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog
      title="新增properties参数"
      :visible.sync="propertyParamVisible"
      width="30%"
      :before-close="handleClosePropertyDialog">
      <el-form :inline="true">
        <el-form-item>
          <el-input placeholder="key" v-model="tmpProperty.key" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="value" v-model="tmpProperty.value" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitProperty">
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-card style="margin: 0 10px">
      <el-table :data="tableData">
        <el-table-column
          v-for="col of tableColumns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="view(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="limit"
        style="float: right"
        @current-change="changePage">
      </el-pagination>
    </el-card>
    <el-dialog
      title="事件详情"
      :visible.sync="detailDialogVisible"
      width="40%"
      :before-close="handleClose">
       <vue-json-pretty :data="selectedRow" > </vue-json-pretty>
    </el-dialog>

  </div>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

const JSONbig = require('json-bigint');

const tableColumns = [
  { prop: 'time', label: 'Time', width: 200 },
  { prop: 'app_id', label: 'AppId', width: 100 },
  { prop: 'event', label: 'Event', width: 100 },
  { prop: 'method_name', label: '埋点方式', width: 100 },
  { prop: 'device_id', label: 'DeviceId', width: 200 },
  { prop: 'device_id2', label: 'IDFV/AndroidId', width: 200 },
  { prop: 'user_id', label: 'UserId', width: 120 },
  { prop: 'os_type_name', label: 'OsType', width: 80 },
  { prop: 'app_version', label: 'AppVersion', width: 120 },
  { prop: 'device_model', label: 'DeviceModel', width: 120 },
  // { prop: 'lng', label: 'Lng', width: 100 },
  // { prop: 'lat', label: 'Lat', width: 100 },
  // { prop: 'type', label: 'Type', width: 100 },
  // { prop: 'network_type', label: 'Network', width: 100 },
  // { prop: 'timestamp', label: 'Timestamp', width: 150 },
  { prop: 'propertiesStr', label: 'Properties', width: 400 }
]

const MethodMap = {
  1: '客户端',
  2: '客户端',
  3: '服务端'
}

const OsTypeMap = {
  1: 'Android',
  2: 'IOS',
  4: 'Web',
}

const OstypeMap = {
}

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      limit: 12,
      totalCount: 0,
      timestamp: 0,
      searchParams: {
        production: true,
        device_id: undefined,
        device_id2: undefined,
        method: undefined,
        event: '',
        user_id: '',
        properties: [],
      },
      tmpProperty: { key: '', value: ''},
      events: [],
      propertyParamVisible: false,
      detailDialogVisible: false,
      tableColumns: tableColumns,
      selectedRow: undefined,
      tableData: [],
      esEvents: []
    }
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    async getEvents() {

      let url =  `/etp/v1.0/event/list?app_id=${this.$store.state.appId}&status=-1`;
      let rst = await this.$http.get(url);

      let events  = rst.data.data;
      this.events = events;

    },

    view(row) {
      if (row.properties) {
        delete row.properties.elm;
        delete row.properties.isRootInsert;
      }

      delete row.propertiesStr;

      this.selectedRow = row;
      this.detailDialogVisible = true;
    },

    handleClose() {
      this.detailDialogVisible = false;
    },
    handleClosePropertyDialog() {
      this.propertyParamVisible = false;
    },

    async queryEvents() {

      this.tableData = [];

      let url = `/etp/v1.0/es/event/list`

      let params = JSON.parse(JSON.stringify(this.searchParams));
      params.app_id = this.$store.state.appId;

      for (let k in params) {
        if (!params[k]) {
          delete params[k]
        }
      }

      let rst = await this.$http.post(url, params);
      let data = JSONbig.parse(rst.bodyText);

      let esEvents = data.data || [];

      esEvents.forEach(d => {
        d.device_id     = (d.device_id || '').toString();
        d.propertiesStr = JSON.stringify(d.properties || {});
        d.os_type_name  = OsTypeMap[d.os_type];
        d.method_name   = MethodMap[d.method];
        let dt = new Date(d.timestamp);
        d.time = dt.toISOString();
      })

      this.totalCount = esEvents.length;
      this.esEvents = esEvents;

      this.changePage(1);

    },

    changePage(val) {
      let start = (val - 1) * this.limit;
      let end   = val * this.limit;
      this.tableData = this.esEvents.slice(start, end);
    },
    addPropertyParams() {
      this.tmpProperty = { key: '', value: ''};
      this.propertyParamVisible = true;
    },
    submitProperty() {

      let { key, value, idx } = this.tmpProperty;
      key = key.trim()
      value = value.trim()

      if (!key) {
        this.$notify.error({
          title: '错误',
          message: 'key不能为空'
        });
      }

      if (idx == undefined) {
        this.searchParams.properties.push({ key, value });
      } else {
        this.searchParams.properties[idx] = {key, value};
      }
      this.propertyParamVisible = false;

    },
		handleEditTag(idx) {
      let d = JSON.parse(JSON.stringify(this.searchParams.properties[idx]));
      d.idx = idx;
      this.tmpProperty = d;
      this.propertyParamVisible = true;
    },
		handleCloseTag(idx) {
      this.searchParams.properties.splice(idx, 1);
    }
  }
}
</script>
<style lang='less' scoped>
</style>
